import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as changePlanzone from "./changePlanzone";
import * as editOrganization from "./editOrganization";
import * as retrieveCurrentPlanzone from "./retrieveCurrentPlanzone";
import * as retrieveOrganization from "./retrieveOrganization";
import * as retrievePersonalSynthesis from "./retrievePersonalSynthesis";
import * as retrievePlanzones from "./retrievePlanzones";
import * as updatePlanzoneContacts from "./updatePlanzoneContacts";
import * as retrievePlanzoneSettings from "./retrievePlanzoneSettings";
import * as editPlanzoneSettings from "./editPlanzoneSettings";
import * as retrieveWbsConfiguration from "./retrieveWbsConfiguration";
import * as editWbsConfiguration from "./editWbsConfiguration";
import * as retrieveProjectListingConfiguration from "./retrieveProjectListingConfiguration";
import * as editProjectListingConfiguration from "./editProjectListingConfiguration";
import * as retrieveResourcesListingConfiguration from "./retrieveResourcesListingConfiguration";
import * as editResourcesListingConfiguration from "./editResourcesListingConfiguration";
import * as retrieveTimeRecordsListingConfiguration from "./retrieveTimeRecordsListingConfiguration";
import * as editTimeRecordsListingConfiguration from "./editTimeRecordsListingConfiguration";
import * as retrieveProjectMembersListingConfiguration from "./retrieveProjectMembersListingConfiguration";
import * as editProjectMembersListingConfiguration from "./editProjectMembersListingConfiguration";
import * as assignDefaultCalendarHolidaysToPlanzone from "./assignDefaultCalendarHolidaysToPlanzone";
import * as retrieveDefaultCalendarHolidays from "./retrieveDefaultCalendarHolidays";
import * as retrieveProjectElementDetailsConfiguration from "./retrieveProjectElementDetailsConfiguration";
import * as editProjectElementDetailsConfiguration from "./editProjectElementDetailsConfiguration";
import * as retrieveProjectDetailsConfiguration from "./retrieveProjectDetailsConfiguration";
import * as editProjectDetailsConfiguration from "./editProjectDetailsConfiguration";
import * as changePlanzoneLogo from "./changePlanzoneLogo";
import * as addIdentityProvider from "./addIdentityProvider";
import * as retrieveIdentityProviders from "./retrieveIdentityProviders";
import * as removeIdentityProvider from "./removeIdentityProvider";
import * as editIdentityProvider from "./editIdentityProvider";
import * as retrieveResourceDetailsConfiguration from "./retrieveResourceDetailsConfiguration";
import * as editResourceDetailsConfiguration from "./editResourceDetailsConfiguration";
import * as editTimesheetDeadline from "./editTimesheetDeadline";
import * as editAllocationWarning from "./editAllocationWarning";

const initialState: State = {
  changePlanzone: changePlanzone.initialState,
  editOrganization: editOrganization.initialState,
  retrieveCurrentPlanzone: retrieveCurrentPlanzone.initialState,
  retrieveOrganization: retrieveOrganization.initialState,
  retrievePersonalSynthesis: retrievePersonalSynthesis.initialState,
  retrievePlanzones: retrievePlanzones.initialState,
  updatePlanzoneContacts: updatePlanzoneContacts.initialState,
  retrievePlanzoneSettings: retrievePlanzoneSettings.initialState,
  editPlanzoneSettings: editPlanzoneSettings.initialState,
  retrieveWbsConfiguration: retrieveWbsConfiguration.initialState,
  editWbsConfiguration: editWbsConfiguration.initialState,
  retrieveProjectListingConfiguration:
    retrieveProjectListingConfiguration.initialState,
  editProjectListingConfiguration: editProjectListingConfiguration.initialState,
  retrieveResourcesListingConfiguration:
    retrieveResourcesListingConfiguration.initialState,
  editResourcesListingConfiguration:
    editResourcesListingConfiguration.initialState,
  retrieveTimeRecordsListingConfiguration:
    retrieveTimeRecordsListingConfiguration.initialState,
  editTimeRecordsListingConfiguration:
    editTimeRecordsListingConfiguration.initialState,
  retrieveProjectMembersListingConfiguration:
    retrieveProjectMembersListingConfiguration.initialState,
  editProjectMembersListingConfiguration:
    editProjectMembersListingConfiguration.initialState,
  assignDefaultCalendarHolidaysToPlanzone:
    assignDefaultCalendarHolidaysToPlanzone.initialState,
  retrieveDefaultCalendarHolidays: retrieveDefaultCalendarHolidays.initialState,
  retrieveProjectElementDetailsConfiguration:
    retrieveProjectElementDetailsConfiguration.initialState,
  editProjectElementDetailsConfiguration:
    editProjectElementDetailsConfiguration.initialState,
  retrieveProjectDetailsConfiguration:
    retrieveProjectDetailsConfiguration.initialState,
  editProjectDetailsConfiguration: editProjectDetailsConfiguration.initialState,
  changePlanzoneLogo: changePlanzoneLogo.initialState,
  addIdentityProvider: addIdentityProvider.initialState,
  retrieveIdentityProviders: retrieveIdentityProviders.initialState,
  removeIdentityProvider: removeIdentityProvider.initialState,
  editIdentityProvider: editIdentityProvider.initialState,
  retrieveResourceDetailsConfiguration:
    retrieveResourceDetailsConfiguration.initialState,
  editResourceDetailsConfiguration:
    editResourceDetailsConfiguration.initialState,
  editTimesheetDeadline: editTimesheetDeadline.initialState,
  editAllocationWarning: editAllocationWarning.initialState,
};

const reduceState = combineStateReducer(initialState, {
  changePlanzone: changePlanzone.reduceState,
  editOrganization: editOrganization.reduceState,
  retrieveCurrentPlanzone: retrieveCurrentPlanzone.reduceState,
  retrieveOrganization: retrieveOrganization.reduceState,
  retrievePersonalSynthesis: retrievePersonalSynthesis.reduceState,
  retrievePlanzones: retrievePlanzones.reduceState,
  updatePlanzoneContacts: updatePlanzoneContacts.reduceState,
  retrievePlanzoneSettings: retrievePlanzoneSettings.reduceState,
  editPlanzoneSettings: editPlanzoneSettings.reduceState,
  retrieveWbsConfiguration: retrieveWbsConfiguration.reduceState,
  editWbsConfiguration: editWbsConfiguration.reduceState,
  retrieveProjectListingConfiguration:
    retrieveProjectListingConfiguration.reduceState,
  editProjectListingConfiguration: editProjectListingConfiguration.reduceState,
  retrieveResourcesListingConfiguration:
    retrieveResourcesListingConfiguration.reduceState,
  editResourcesListingConfiguration:
    editResourcesListingConfiguration.reduceState,
  retrieveTimeRecordsListingConfiguration:
    retrieveTimeRecordsListingConfiguration.reduceState,
  editTimeRecordsListingConfiguration:
    editTimeRecordsListingConfiguration.reduceState,
  retrieveProjectMembersListingConfiguration:
    retrieveProjectMembersListingConfiguration.reduceState,
  editProjectMembersListingConfiguration:
    editProjectMembersListingConfiguration.reduceState,
  assignDefaultCalendarHolidaysToPlanzone:
    assignDefaultCalendarHolidaysToPlanzone.reduceState,
  retrieveDefaultCalendarHolidays: retrieveDefaultCalendarHolidays.reduceState,
  retrieveProjectElementDetailsConfiguration:
    retrieveProjectElementDetailsConfiguration.reduceState,
  editProjectElementDetailsConfiguration:
    editProjectElementDetailsConfiguration.reduceState,
  retrieveProjectDetailsConfiguration:
    retrieveProjectDetailsConfiguration.reduceState,
  editProjectDetailsConfiguration: editProjectDetailsConfiguration.reduceState,
  changePlanzoneLogo: changePlanzoneLogo.reduceState,
  addIdentityProvider: addIdentityProvider.reduceState,
  retrieveIdentityProviders: retrieveIdentityProviders.reduceState,
  removeIdentityProvider: removeIdentityProvider.reduceState,
  editIdentityProvider: editIdentityProvider.reduceState,
  retrieveResourceDetailsConfiguration:
    retrieveResourceDetailsConfiguration.reduceState,
  editResourceDetailsConfiguration:
    editResourceDetailsConfiguration.reduceState,
  editTimesheetDeadline: editTimesheetDeadline.reduceState,
  editAllocationWarning: editAllocationWarning.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...changePlanzone.createSelector(() => getState().changePlanzone),
    ...editOrganization.createSelector(() => getState().editOrganization),
    ...retrieveCurrentPlanzone.createSelector(
      () => getState().retrieveCurrentPlanzone,
    ),
    ...retrieveOrganization.createSelector(
      () => getState().retrieveOrganization,
    ),
    ...retrievePersonalSynthesis.createSelector(
      () => getState().retrievePersonalSynthesis,
    ),
    ...retrievePlanzones.createSelector(() => getState().retrievePlanzones),
    ...updatePlanzoneContacts.createSelector(
      () => getState().updatePlanzoneContacts,
    ),
    ...retrievePlanzoneSettings.createSelector(
      () => getState().retrievePlanzoneSettings,
    ),
    ...editPlanzoneSettings.createSelector(
      () => getState().editPlanzoneSettings,
    ),
    ...retrieveWbsConfiguration.createSelector(
      () => getState().retrieveWbsConfiguration,
    ),
    ...editWbsConfiguration.createSelector(
      () => getState().editWbsConfiguration,
    ),
    ...retrieveProjectListingConfiguration.createSelector(
      () => getState().retrieveProjectListingConfiguration,
    ),
    ...editProjectListingConfiguration.createSelector(
      () => getState().editProjectListingConfiguration,
    ),
    ...retrieveResourcesListingConfiguration.createSelector(
      () => getState().retrieveResourcesListingConfiguration,
    ),
    ...editResourcesListingConfiguration.createSelector(
      () => getState().editResourcesListingConfiguration,
    ),
    ...retrieveTimeRecordsListingConfiguration.createSelector(
      () => getState().retrieveTimeRecordsListingConfiguration,
    ),
    ...editTimeRecordsListingConfiguration.createSelector(
      () => getState().editTimeRecordsListingConfiguration,
    ),
    ...retrieveProjectMembersListingConfiguration.createSelector(
      () => getState().retrieveProjectMembersListingConfiguration,
    ),
    ...editProjectMembersListingConfiguration.createSelector(
      () => getState().editProjectMembersListingConfiguration,
    ),
    ...assignDefaultCalendarHolidaysToPlanzone.createSelector(
      () => getState().assignDefaultCalendarHolidaysToPlanzone,
    ),
    ...retrieveDefaultCalendarHolidays.createSelector(
      () => getState().retrieveDefaultCalendarHolidays,
    ),
    ...retrieveProjectElementDetailsConfiguration.createSelector(
      () => getState().retrieveProjectElementDetailsConfiguration,
    ),
    ...editProjectElementDetailsConfiguration.createSelector(
      () => getState().editProjectElementDetailsConfiguration,
    ),
    ...retrieveProjectDetailsConfiguration.createSelector(
      () => getState().retrieveProjectDetailsConfiguration,
    ),
    ...editProjectDetailsConfiguration.createSelector(
      () => getState().editProjectDetailsConfiguration,
    ),
    ...changePlanzoneLogo.createSelector(() => getState().changePlanzoneLogo),
    ...addIdentityProvider.createSelector(() => getState().addIdentityProvider),
    ...retrieveIdentityProviders.createSelector(
      () => getState().retrieveIdentityProviders,
    ),
    ...removeIdentityProvider.createSelector(
      () => getState().removeIdentityProvider,
    ),
    ...editIdentityProvider.createSelector(
      () => getState().editIdentityProvider,
    ),
    ...retrieveResourceDetailsConfiguration.createSelector(
      () => getState().retrieveResourceDetailsConfiguration,
    ),
    ...editResourceDetailsConfiguration.createSelector(
      () => getState().editResourceDetailsConfiguration,
    ),
    ...editTimesheetDeadline.createSelector(
      () => getState().editTimesheetDeadline,
    ),
    ...editAllocationWarning.createSelector(
      () => getState().editAllocationWarning,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
